import {Injectable} from "@angular/core";
import {HttpClient} from "@angular/common/http";
import {environment} from "@env";
import {firstValueFrom} from "rxjs";

@Injectable({ providedIn: 'root' })
export class ChatTreeService {

  constructor(private http: HttpClient) {
  }
  private baseUrl = environment.externalUrls.bff;
  private chatTreesUrl = `${this.baseUrl}/chat-tree`;

  public async installedAppsByParameters(companyIds: string[], withApps = false): Promise<any> {
    const companiesIds = companyIds.join(',');
    return firstValueFrom(this.http.get(this.chatTreesUrl + '/apps-by-param?appsCompanyIds=' + companiesIds, {
      params: {
        withApps: String(withApps),
        companiesIds
      }
    }));
  }

}
